import useUpload from 'hooks/useDocUpload'
import { useEffect } from 'react'
import { Mode } from 'types'

import UploadDialog from './Dialog'
import { resetInitialFiles } from './initialFiles'

export type Props = {
  open: boolean
  setOpen: (f: boolean) => void
  mode: Mode
}

const UploadDialogContainer = ({ open, setOpen, mode }: Props) => {
  const { onImportTypeChange, onGroupChange, onDocTypeChange, onSend, onAddFiles, reset, ...rest } =
    useUpload(mode)

  useEffect(() => {
    if (open) {
      onAddFiles(resetInitialFiles() || [])
    }
  }, [onAddFiles, open])

  useEffect(() => {
    if (!open) {
      reset()
    }
  }, [open, reset])

  const closeDialog = () => {
    setOpen(false)
  }
  const handleTypeSelect = (value: string) => {
    onDocTypeChange(value)
  }
  const handleGroupSelect = (e) => {
    onGroupChange(e.target?.value)
  }

  const handleImportTypeSelect = (e) => {
    onImportTypeChange(e.target?.value)
  }

  const handleSend = async () => {
    await onSend()
    closeDialog()
  }

  return (
    <UploadDialog
      mode={mode}
      open={open}
      onAddFiles={onAddFiles}
      onGroupSelect={handleGroupSelect}
      onImportTypeSelect={handleImportTypeSelect}
      onClose={closeDialog}
      onDocTypeSelect={handleTypeSelect}
      onSend={handleSend}
      {...rest}
    />
  )
}

export default UploadDialogContainer
